import { defineStore } from 'pinia'

const useCategoryStore = defineStore('category', {
  state: () => ({
    // add initial state here
  }),
  actions: {
    // add actions here
  },
})

export default useCategoryStore
